import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Input, InputField } from "@/components/ui/input";
import { HStack } from "@/components/ui/hstack";
import React, { useState, useEffect } from "react";
import i18n from "i18n-js";
import BasicButton from "@/components/basic/BasicButton";
import CancelButton from "@/components/basic/CancelButton";
import Moment from 'moment';
import ModalBase from "@/components/basic/ModalBase";

const format = (number, max) => {
    if (+number > +max) {
        number = max
    }
    number = '00' + number
    number = number.substring(number.length - 2);
    return number
}

export default function ModalTime({ showModal, setShowModal, title, date, setDate }) {
    const [hours, setHours] = useState(Moment(date).format('HH'))
    const [minutes, setMinutes] = useState(Moment(date).format('mm'))

    useEffect(() => {
        setHours(Moment(date).format('HH'))
        setMinutes(Moment(date).format('mm'))
    }, [date])

    const setTime = () => {
        setDate(Moment(date).set({ hour: hours, minute: minutes }))
        setShowModal(false)
    }

    return (
        <ModalBase showModal={showModal}>
            <Text className="text-2xl leading-2xl text-secondary-900">{i18n.t(title)}</Text>
            <HStack space='xs'>
                <VStack space='xs'>
                    <Input className="w-[80px] h-[60px]">
                        <InputField maxLength={2} variant='filled' placeholder='00' value={hours} keyboardType={'number-pad'} onChangeText={text => setHours(Math.min(+text, 23))} selectionColor={"#D2D4D7"} className="font-Assistant text-4xl font-[700] text-secondary-900 bg-transparent text-center" />
                    </Input>
                    <Text className="text-xl leading-2xl text-secondary-900">{i18n.t('modalTime.hour')}</Text>
                </VStack>
                <Text className="text-black font-bold mt-4 text-4xl leading-3xl">:</Text>
                <VStack space='xs'>
                    <Input className="w-[80px] h-[60px]">
                        <InputField maxLength={2} variant='filled' placeholder='00' value={minutes} keyboardType={'number-pad'} onChangeText={text => setMinutes(Math.min(+text, 59))} selectionColor={"#D2D4D7"} className="font-Assistant text-4xl font-[700] text-secondary-900 bg-transparent text-center" />
                    </Input>
                    <Text className="text-xl leading-2xl text-secondary-900">{i18n.t('modalTime.minute')}</Text>
                </VStack>
            </HStack>
            <VStack space='sm' className="pt-3 w-[100%]">
                <BasicButton onPress={() => setTime()} text={i18n.t('modalTime.ok')} />
                <CancelButton onPress={() => setShowModal(false)} text={i18n.t('modalTime.cancel')} />
            </VStack>
        </ModalBase>
    );
}
